import { render, staticRenderFns } from "./AccidentIntakeReviewSubmitForm.vue?vue&type=template&id=085db6cc&scoped=true"
import script from "./AccidentIntakeReviewSubmitForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeReviewSubmitForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeReviewSubmitForm.vue?vue&type=style&index=0&id=085db6cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085db6cc",
  null
  
)

export default component.exports